import { toolsConstants } from "../action-types";

const initialState = {
  otherDocsData: [],
  otherDocsLoading: false,
  triggerOtherDocsDataFetch: [],
};

const CommonToolsReducer = (state = initialState, action) => {
  switch (action.type) {
    case toolsConstants.OTHER_DOCS_DATA_LOADING:
      return {
        ...state,
        otherDocsLoading: action.otherDocsLoading,
      };
    case toolsConstants.OTHER_DOCS_DATA_SUCCESS:
      return {
        ...state,
        otherDocsData: action.otherDocsData,
        otherDocsLoading: false,
      };
    case toolsConstants.TRIGGER_OTHER_DOCS_DATA_FETCH:
      return {
        ...state,
        triggerOtherDocsDataFetch: [],
      };
    default:
      return state;
  }
};

export { CommonToolsReducer };
